import { FILTER_SUBMENU_OPTION_DELIMITER } from 'modules/missionControl/constants';
import { ResourceType } from 'modules/missionControl/lib/types';
import { useMemo } from 'react';
import { match } from 'ts-pattern';
import { BASE_LAUNCHPAD_FILTER_OPTIONS, LaunchpadFilter } from '../Launchpad.constants';
import { ActionType } from '../Launchpad.types';

export const useLaunchpadFilterOptions = (hasCountBadge: Record<LaunchpadFilter, boolean>) => {
  const filterOptions = useMemo(() => {
    const actionTypeOptions = Object.entries(ActionType).map(([label, id]) => ({
      id: `${LaunchpadFilter.ACTION_TYPE}${FILTER_SUBMENU_OPTION_DELIMITER}${id}`,
      label,
    }));

    const resourceTypeOptions = Object.entries(ResourceType).map(([label, id]) => ({
      id: `${LaunchpadFilter.RESOURCE_TYPE}${FILTER_SUBMENU_OPTION_DELIMITER}${id}`,
      label: label.replace('Journey', ' Journey'),
    }));

    return BASE_LAUNCHPAD_FILTER_OPTIONS.map((option) => ({
      ...option,
      hasCountBadge: hasCountBadge[option.id as LaunchpadFilter],
      options: match(option.id)
        .with(LaunchpadFilter.ACTION_TYPE, () => actionTypeOptions)
        .with(LaunchpadFilter.RESOURCE_TYPE, () => resourceTypeOptions)
        .otherwise(() => option.options),
    }));
  }, [hasCountBadge]);

  return filterOptions;
};
